module.exports = __webpack_public_path__ + "img/IMG_0328_L.3933545a.webp";